





import { Component, Vue } from 'vue-property-decorator'
import QuizPreview2 from './QuizPreview2.vue'

@Component({ components: { QuizPreview2 } })
export default class QuizPreviewPopup extends Vue {
  customQuizId = ''
  isPreview = false

  setData(quizId: string, isPreview = false) {
    this.customQuizId = quizId
    this.isPreview = isPreview
  }

  reset() {
    this.customQuizId = ''
  }

  handleOpen() {
    console.log(123)
  }

  handleClose() {
    this.reset()
    if (this.isPreview) {
      this.$emit('refresh')
    }
  }
}
